// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__ZENf9","selected":"Chip_selected__3lahB"};